/* eslint-disable */
;(function() {
  'use strict';

  var mobileNavCheckbox = document.getElementById('default-nav-mobile-show');

  // Polyfill for IE and mobile browsers
  if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function(string) {
      var i = this.indexOf(string);
      return i !== -1 && i === this.length - string.length - 1;
    }
  }

  function smoothScrollToId(id) {
    var element = document.getElementById(id);

    return function() {
      var target = element && typeof element.getBoundingClientRect === 'function'
        ? element.getBoundingClientRect().top || 0
        : 0;

      mobileNavCheckbox.checked = false; // Close the mobile menu
      window.smoothScrollToPx(document.body.scrollTop + document.documentElement.scrollTop + target);
    };
  }

  function smoothScrollToTarget(element) {
    var parts = element.href.split('#');
    var doc = parts[0];
    var targetId = parts[1];

    // If the target is not on the same document, abort
    if (doc !== '' && !document.location.href.split('#')[0].endsWith(doc)) {
      return;
    }

    element.addEventListener('click', smoothScrollToId(targetId));
  }

  function setupSmoothScrolling() {
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href*="#"]'),
      smoothScrollToTarget
    );
  }

  document.addEventListener('DOMContentLoaded', setupSmoothScrolling);
}());
